import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { sendBrowserError } from '@unisporkal/instrumentation/dist/client';
import App from 'app/App.tsx';
import { siteComponent } from 'app/root-components/siteComponent';
import { hydrateFederatedComponents } from '@unisporkal/federation';
import { PageErrorBoundary } from '@unisporkal/react-instrumentation';

hydrateFederatedComponents();

function loadJSONPayload(componentName) {
  const element = document.querySelector(
    `script[data-component=${componentName}]`
  );
  if (!element) return {};
  return JSON.parse(element.innerHTML);
}

const elements = document.querySelectorAll(
  "[data-component][data-app='landing']"
);

elements.forEach((element) => {
  const componentName = element.getAttribute('data-component');
  const prerender = element.getAttribute('data-prerender') === 'true';
  const payload = loadJSONPayload(componentName);
  const site = payload.site.nickname;

  const experiences = window?.experiences || {};
  const Component = siteComponent(site, componentName);

  const app = (
    <App
      experiences={experiences}
      payload={payload}
    >
      <PageErrorBoundary
        appName="landing"
        component={componentName}
        site={site}
      >
        <Component payload={payload} />
      </PageErrorBoundary>
    </App>
  );

  if (prerender) {
    hydrateRoot(element, app, {
      onRecoverableError(error, errorInfo) {
        sendBrowserError(error, { stack: errorInfo.componentStack });
      },
    });
  } else {
    const root = createRoot(element);
    root.render(app, element);
  }
});
